import { ReloadOutlined } from "@ant-design/icons";
import { Button, Slider, Typography } from "antd";
import React, { useCallback, useState } from "react";
import TriggerInit from "./trigger/trigger_init";
import TriggerChange from "./trigger/trigger_change";
import TriggerPlay from "./trigger/trigger_play";
import TriggerMonitor from "./trigger/trigger_monitor";
import TriggerOver from "./trigger/trigger_over";
import { FaPause, FaPlay } from "react-icons/fa6";
import { useDispatch } from "react-redux";
import { setDraftDialogPlay } from "store/bailiff/draft/dialog/draft_dialog.action";
import {
  draftDialogPlaySelector,
  draftDialogSecondSelector,
} from "store/bailiff/draft/dialog/draft_dialog.selector";
import { useSelector } from "react-redux";
import moment from "moment";
import { refineTimer } from "util/refine_timer.function";
import TriggerKeyboard from "./trigger/trigger_keyboard";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const PLAYBACK_RATE = [
  {
    value: 0.75,
    label: "Chậm (x0.75)",
  },
  {
    value: 1,
    label: "Bình Thường (x1)",
  },
  {
    value: 2,
    label: "Nhanh (x2)",
  },
];

const PreviewPlayback = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  const [playbackRate, setPlaybackRate] = useState(1);
  const [audio, setAudio] = useState(null);
  const [duration, setDuration] = useState(0);
  const [trigger, setTrigger] = useState(null);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const play = useSelector(draftDialogPlaySelector);
  const second = useSelector(draftDialogSecondSelector);
  const lableRate = PLAYBACK_RATE?.[playbackRate]?.label;

  // -------------------------- FUNCTION ------------------------
  const togglePlay = useCallback(() => {
    console.log("click!");
    dispatch(setDraftDialogPlay(!play));
  }, [dispatch, play]);

  const handleChange = (value) => {
    if (!audio) return;
    const id = `change-${moment()?.valueOf()}-${value}`;
    setTrigger(id);
  };

  const handleNext10s = () => {
    if (!audio) return;
    if (second + 10 > duration) return;
    const id = `change-${moment()?.valueOf()}-${second + 10}`;
    setTrigger(id);
  };

  const handlePrev10s = () => {
    if (!audio) return;
    if (second - 10 < 0) return;
    const id = `change-${moment()?.valueOf()}-${second - 10}`;
    setTrigger(id);
  };

  const handlePlayBackRate = () => {
    if (!audio) return;
    if (playbackRate < 2) {
      let increase = playbackRate + 1;
      setPlaybackRate(increase);
      const rate = PLAYBACK_RATE?.[increase]?.value;
      audio.playbackRate = rate;
    } else {
      let decrease = 0;
      setPlaybackRate(decrease);
      const rate = PLAYBACK_RATE?.[decrease]?.value;
      audio.playbackRate = rate;
    }
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderSlider = () => {
    return (
      <div className="relative mb-2 flex h-8 flex-row items-center gap-x-3 px-2">
        <Typography.Text type="secondary" className="text-[10px]">
          {refineTimer({ timer: parseInt(second) })}
        </Typography.Text>
        <Slider
          value={second}
          onChange={handleChange}
          className="flex-1"
          defaultValue={0}
          min={0}
          max={duration}
          tooltip={{ open: false }}
          handleStyle={{
            borderColor: "#3b82f6",
            backgroundColor: "#fff",
          }}
          trackStyle={{ backgroundColor: "#3b82f6" }}
        />
        <Typography.Text type="secondary" className="text-[10px]">
          {refineTimer({ timer: duration })}
        </Typography.Text>
      </div>
    );
  };

  const renderPlayBackRate = () => {
    return (
      <Button
        onClick={handlePlayBackRate}
        type="text"
        shape="round"
        size="middle"
        className="absolute left-10 items-center gap-1 border-gray-200 text-sm font-medium text-gray-500"
      >
        {lableRate}
      </Button>
    );
  };

  const renderControls = () => {
    return (
      <div className="flex items-center justify-center gap-6">
        {renderPlayBackRate()}
        <div className="flex flex-col items-center gap-3">
          <div className="flex flex-row items-center gap-6">
            <Button
              onClick={handlePrev10s}
              type="text"
              shape="circle"
              icon={<ReloadOutlined style={{ transform: "scaleX(-1)" }} />}
              className="text-2xl text-blue-500"
            />
            <Button
              onClick={togglePlay}
              type="primary"
              shape="circle"
              size="large"
              className="flex w-[60px] items-center justify-center bg-blue-500 shadow-lg shadow-blue-500/30"
              icon={
                play ? (
                  <FaPause className="text-xl" />
                ) : (
                  <FaPlay className="text-xl" />
                )
              }
            />
            <Button
              onClick={handleNext10s}
              type="text"
              shape="circle"
              icon={<ReloadOutlined />}
              className="h-[40px] w-[40px] text-2xl text-blue-500"
            />
          </div>
          <span className="text-[10px] font-semibold uppercase tracking-wider text-gray-400">
            SHIFT + SPACE
          </span>
        </div>
      </div>
    );
  };
  // -------------------------- MAIN ----------------------------
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 flex justify-center p-4 py-8">
      <div className="glass-panel w-full max-w-4xl rounded-xl border border-gray-200 bg-white/90 p-4 shadow-xl backdrop-blur-md">
        {renderSlider()}
        {renderControls()}
        <div className="mt-1 text-center"></div>
        <TriggerPlay audio={audio} />
        <TriggerMonitor audio={audio} />
        <TriggerInit setAudio={setAudio} setDuration={setDuration} />
        <TriggerOver
          start={0}
          end={duration}
          audio={audio}
          setTrigger={setTrigger}
        />
        <TriggerChange audio={audio} trigger={trigger} />
        <TriggerKeyboard togglePlay={togglePlay} />
      </div>
    </div>
  );
};
export default PreviewPlayback;
